import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import NewsTicker from "@/pages/home/components/NewsTicker";
import EntryIndex from "@/pages/home/components/EntryIndex";
import FeaturedCollections from "@/pages/home/components/FeaturedCollections";
import QuickBites from "@/pages/home/components/QuickBites";
import CategoryIndex from "@/pages/home/components/CategoryIndex";
import AccessNotice from "@/pages/home/components/AccessNotice";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <NewsTicker />
        <EntryIndex />
        <FeaturedCollections />
        <QuickBites />
        <CategoryIndex />
        <AccessNotice />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}